import { render, staticRenderFns } from "./DepartmentDescription.vue?vue&type=template&id=6a2ac971"
import script from "./DepartmentDescription.vue?vue&type=script&lang=js"
export * from "./DepartmentDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports